import React, { useState, useEffect } from 'react';
import { Container, Grid, TextField, Checkbox, FormControlLabel } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { CampaignType, CampaignStatus } from '../../../utils/enums'
import UsersAutoComplete from '../../Users/UsersAutoComplete';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const EditForm = ({ campaignData, onSubmit, loading }) => {
    const [focusedField, setFocusedField] = useState(null); // Track the focused field

    const [ownerId, setOwnerId] = useState('');
    const [campaignName, setCampaignName] = useState('');
    const [startDate, setStartDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs());
    const [expectedRevenue, setExpectedRevenue] = useState(0);
    const [actualCost, setActualCost] = useState(0);
    const [budgetedCost, setBudgetedCost] = useState(0);
    const [numbersSent, setNumbersSent] = useState(0);
    const [expectedResponse, setExpectedResponse] = useState(0);
    const [type, setType] = useState(0);
    const [status, setStatus] = useState(0);
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (campaignData) { 
            setOwnerId(campaignData.ownerId || ''); 
            setCampaignName(campaignData.campaignName || '');
            setStartDate(dayjs(campaignData.startDate) || dayjs());
            setEndDate(dayjs(campaignData.dueDate) || dayjs());
            setExpectedRevenue(campaignData.expectedRevenue || 0);
            setActualCost(campaignData.actualCost || 0);
            setBudgetedCost(campaignData.budgetedCost || 0);
            setNumbersSent(campaignData.numbersSent || 0);
            setExpectedResponse(campaignData.expectedResponse || 0);
            setType(campaignData.type || 0);
            setStatus(campaignData.status || 0);
            setDescription(campaignData.description || '');
        }
    }, [campaignData]);
    

    const handleSubmit = (e) => {
        e.preventDefault();
        // Collect all form data
        const formData = {
            ownerId,
            campaignName,
            startDate,
            endDate,
            expectedRevenue,
            actualCost,
            budgetedCost,
            numbersSent,
            expectedResponse,
            type,
            status,
            description
        };
        // Call onSubmit function passed as a prop
        onSubmit(formData);
    };
    return (
        <form id='create-form' onSubmit={handleSubmit}>
            <Container maxWidth="md" sx={{ marginTop: "10px" }}>
                <h4>Campaign Information</h4>
                <Grid container spacing={3}>
                    {/* Campaign Owner */}
                    <Grid item xs={12} sm={6}>
                        <UsersAutoComplete setUserId={setOwnerId} userId={ownerId} />
                    </Grid>

                    {/* Type ****** */}
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={CampaignType}
                            sx={{ width: "100%" }}
                            value={CampaignType.find((option) => option.value === type)}
                            onChange={(event, newValue) => setType(newValue ? newValue.value : '')}
                            renderInput={(params) => <TextField {...params} label="Type" />}
                        />
                    </Grid>

                    {/* Campaign Name */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Campaign Name" required
                            value={campaignName}
                            onChange={(e) => setCampaignName(e.target.value)} />
                    </Grid>

                    {/* Status */}
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={CampaignStatus}
                            sx={{ width: "100%" }}
                            value={CampaignStatus.find((option) => option.value === status)}
                            onChange={(event, newValue) => setStatus(newValue ? newValue.value : '')}
                            renderInput={(params) => <TextField {...params} label="Status" />}
                        />
                    </Grid>

                    {/* Start Date */}
                    <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Start Date"
                                fullWidth
                                value={startDate}
                                onChange={(newDate) => setStartDate(newDate)}
                                slotProps={{
                                    textField: {
                                        variant: 'outlined',
                                        fullWidth: true
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>

                    {/* End Date */}
                    <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="End Date"
                                fullWidth
                                value={endDate}
                                onChange={(newDate) => setEndDate(newDate)}
                                slotProps={{
                                    textField: {
                                        variant: 'outlined',
                                        fullWidth: true
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>

                    {/* Expected Revenue */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Expected Revenue"
                            value={expectedRevenue}
                            onChange={(e) => setExpectedRevenue(e.target.value)} />
                    </Grid>

                    {/* Budgeted Cost */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Budgeted Cost"
                            value={budgetedCost}
                            onChange={(e) => setBudgetedCost(e.target.value)} />
                    </Grid>

                    {/* Actual Cost */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Actual Cost"
                            value={actualCost}
                            onChange={(e) => setActualCost(e.target.value)} />
                    </Grid>

                    {/* Expected Response */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Expected Response"
                            value={expectedResponse}
                            onChange={(e) => setExpectedResponse(e.target.value)} />
                    </Grid>

                    {/* Numbers sent */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Numbers sent"
                            value={numbersSent}
                            onChange={(e) => setNumbersSent(e.target.value)} />
                    </Grid>
                </Grid >
                <br />
                <h4>Description Information</h4>
                <Grid container spacing={3}>
                    {/* Description */}
                    <Grid item xs={12} sm={12}>
                        <TextField multiline fullWidth label="Description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)} />
                    </Grid>
                </Grid >
            </Container >
        </form>
    );
};

export default EditForm;
